import { StoreInterface } from 'src/store'
import { SectionStateInterface } from 'src/store/section/state'
import { ActionContext, ActionTree } from 'vuex'
import { UserGroup } from 'able-lib'

const actions: ActionTree<SectionStateInterface, StoreInterface> = {
  setLevelsAndSections ({ commit }: ActionContext<SectionStateInterface, StoreInterface>, levelsAndSections): void {
    commit('SET_LEVELS_AND_SECTIONS', levelsAndSections)
  },

  setCurrentSectionUsers ({ commit }: ActionContext<SectionStateInterface, StoreInterface>, currentSectionUsers: Array<number>): void {
    commit('SET_CURRENT_SECTION_USERS', currentSectionUsers)
  },

  setStudentList ({ commit }: ActionContext<SectionStateInterface, StoreInterface>, students: Array<UserGroup>): void {
    commit('SET_STUDENT_LIST', students)
  },

  setTeacherList ({ commit }: ActionContext<SectionStateInterface, StoreInterface>, teachers: Array<UserGroup>): void {
    commit('SET_TEACHER_LIST', teachers)
  },

  setSelectedLevel ({ commit }: ActionContext<SectionStateInterface, StoreInterface>, selectedLevel): void {
    commit('SET_SELECTED_LEVEL', selectedLevel)
  }
}

export default actions
